import { toArray } from "../utilities";
import assign from "object-assign";
import * as constants from "../../constants";

var cancelInProgressAnimations = function cancelInProgressAnimations(inProgressAnimations) {
  Object.keys(inProgressAnimations).forEach(function (id) {
    if (inProgressAnimations[id].stop) inProgressAnimations[id].stop();
    delete inProgressAnimations[id];
  });
};

var addTupleToObject = function addTupleToObject(acc, curr) {
  var _assign;

  return assign(acc, (_assign = {}, _assign[curr[0]] = curr[1], _assign));
};

export var getAllElements = function getAllElements(element, portalKey) {
  if (portalKey) {
    return toArray(document.querySelectorAll("[" + constants.DATA_PORTAL_KEY + "=\"" + portalKey + "\"]"));
  } else {
    return toArray(element.querySelectorAll("[" + constants.DATA_FLIP_ID + "]"));
  }
};
/**
 * Called in getSnapshotBeforeUpdate in the Flipped Component
 * @param {Object} args
 * @param {HTMLElement} args.element - the ref for the parent Flipper component
 * @param {Object} args.flipCallbacks - passed in solely to identify which
 * elements have onExit callbacks, and cache their dom elements appropriately
 * @param {Object} args.inProgressAnimations - stop callbacks for currently in
 * progress animations
 * @returns {Object} flippedElementPositions
 */

export var getFlippedElementPositionsBeforeUpdate = function getFlippedElementPositionsBeforeUpdate(_ref) {
  var element = _ref.element,
      _ref$flipCallbacks = _ref.flipCallbacks,
      flipCallbacks = _ref$flipCallbacks === undefined ? {} : _ref$flipCallbacks,
      _ref$inProgressAnimat = _ref.inProgressAnimations,
      inProgressAnimations = _ref$inProgressAnimat === undefined ? {} : _ref$inProgressAnimat,
      portalKey = _ref.portalKey;
  var flippedElements = getAllElements(element, portalKey);
  var inverseFlippedElements = toArray(element.querySelectorAll("[" + constants.DATA_INVERSE_FLIP_ID + "]"));
  var childIdsToParentBCRs = {};
  var parentBCRs = []; // this is for exit animations so we can re-insert exiting elements in the
  // DOM later

  flippedElements.filter(function (el) {
    return flipCallbacks && flipCallbacks[el.dataset.flipId] && flipCallbacks[el.dataset.flipId].onExit;
  }).forEach(function (el) {
    var parent = el.parentNode;
    var bcrIndex = parentBCRs.findIndex(function (n) {
      return n[0] === parent;
    });

    if (bcrIndex === -1) {
      parentBCRs.push([parent, parent.getBoundingClientRect()]);
      bcrIndex = parentBCRs.length - 1;
    }

    childIdsToParentBCRs[el.dataset.flipId] = parentBCRs[bcrIndex][1];
  });
  var flippedElementPositions = flippedElements.map(function (child) {
    var domData = {};
    var childBCR = child.getBoundingClientRect();

    if (flipCallbacks && flipCallbacks[child.dataset.flipId] && flipCallbacks[child.dataset.flipId].onExit) {
      var parentBCR = childIdsToParentBCRs[child.dataset.flipId];
      assign(domData, {
        element: child,
        parent: child.parentNode,
        childPosition: {
          top: childBCR.top - parentBCR.top,
          left: childBCR.left - parentBCR.left,
          width: childBCR.width,
          height: childBCR.height
        }
      });
    }

    return [child.dataset.flipId, {
      rect: childBCR,
      opacity: parseFloat(window.getComputedStyle(child).opacity),
      flipComponentId: child.dataset.flipComponentId,
      domData: domData
    }];
  }).reduce(addTupleToObject, {}); // do this at the very end since we want to cache positions of elements
  // while they are mid-transition

  cancelInProgressAnimations(inProgressAnimations);
  flippedElements.concat(inverseFlippedElements).forEach(function (el) {
    el.style.transform = "";
    el.style.opacity = "";
  });
  return {
    flippedElementPositions: flippedElementPositions,
    cachedOrderedFlipIds: flippedElements.map(function (el) {
      return el.dataset.flipId;
    })
  };
};
/**
 * This function is called in onFlipKeyUpdate
 * (which is called in the Flipper component's componentDidUpdate)
 * @param {HTMLElement} args.element - the ref for the parent Flipper component
 * @returns {Object} flippedElementPositions
 */

export var getFlippedElementPositionsAfterUpdate = function getFlippedElementPositionsAfterUpdate(_ref2) {
  var element = _ref2.element,
      portalKey = _ref2.portalKey,
      ids = _ref2.ids;
  var els = getAllElements(element, portalKey);
  return els // filter is only for the "waitATickIds"
  .filter(function (child) {
    if (ids) {
      return ids.indexOf(child.dataset.flipId) > -1;
    } else {
      return true;
    }
  }).map(function (child) {
    var computedStyle = window.getComputedStyle(child);
    var rect = child.getBoundingClientRect(); // maybe the image hasn't loaded into the document yet. This is a problem
    // especially with Safari for some reason
    // need to check for either width OR height because one could be set with CSS

    if ((rect.height === 0 || rect.width === 0) && child.tagName === "IMG") {
      return [child.dataset.flipId, "unloadedImg"];
    }

    return [child.dataset.flipId, {
      rect: rect,
      opacity: parseFloat(computedStyle.opacity),
      domData: {},
      transform: computedStyle.transform
    }];
  }).reduce(addTupleToObject, {});
};